import Video from '@assets/video/main_video_v2.mp4';

import * as styles from './styles';
import DefaultContent from '@pages/Main/MainView/components/Banner/components/DefaultContent';
import BannerContent from '@pages/Main/MainView/components/Banner/components/BannerContent';
import { useMainContext } from '@context/Main';

const Banner = () => {
  const { currentBanner } = useMainContext();

  return (
    <div css={styles.bannerContainer}>
      <video css={styles.videoWrapper} loop muted autoPlay src={Video} preload="auto" />
      {currentBanner ? <BannerContent banner={currentBanner} /> : <DefaultContent />}
    </div>
  );
};

export default Banner;
